import {
    FETCH_PRODUCT_LOCALISATION,
    FETCH_PRODUCT_LOCALISATION_FAILURE,
    FETCH_PRODUCT_LOCALISATION_SUCCESS,
    UPDATE_PRODUCT_LOCALISATION,
    UPDATE_PRODUCT_LOCALISATION_SUCCESS,
    UPDATE_PRODUCT_LOCALISATION_FAILURE,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';

const initialState = {
    data: {},
    loading: false,
};

export default function productLocalisation(state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT_LOCALISATION:
        case UPDATE_PRODUCT_LOCALISATION:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_PRODUCT_LOCALISATION_FAILURE:
        case UPDATE_PRODUCT_LOCALISATION_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_PRODUCT_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: reducerHelper.formatLocalisations(action.response.results),
                }),
                loading: false,
            });

        case UPDATE_PRODUCT_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: action.payload.formValues.localisation,
                }),
                loading: false,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/productLocalisationReducer.js